// import generatedAWSAmplifyConfig from "../../amplifyconfiguration.json";

export const MakeAmplifyConfig = (isLoggedIn: boolean) => {
  const poolData = {
    // ...generatedAWSAmplifyConfig,
    // "aws_appsync_graphqlEndpoint": process.env.REACT_APP_GRAPHQL_ENDPOINT_URL,
    // "aws_appsync_authenticationType": isLoggedIn ? "AMAZON_COGNITO_USER_POOLS" : "API_KEY",
    // "aws_cognito_region": process.env.REACT_APP_AWS_POOL_REGION,
    // "aws_user_pools_id": process.env.REACT_APP_AWS_POOL_ID,
    // "aws_user_pools_web_client_id": process.env.REACT_APP_AWS_CLIENT_ID,
    // "aws_cognito_username_attributes": [],
    // "aws_cognito_social_providers": [],
    aws_project_region: process.env.REACT_APP_AWS_POOL_REGION,
    aws_cognito_region: process.env.REACT_APP_AWS_POOL_REGION,
    aws_user_pools_id: process.env.REACT_APP_AWS_POOL_ID,
    aws_user_pools_web_client_id: process.env.REACT_APP_AWS_CLIENT_ID,
    oauth: {}
  };

  // const poolData = {
  //   Auth: {
  //     // REQUIRED - Amazon Cognito Region
  //     region: process.env.REACT_APP_AWS_POOL_REGION,

  //     // OPTIONAL - Amazon Cognito User Pool ID
  //     userPoolId: process.env.REACT_APP_AWS_POOL_ID,

  //     // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
  //     userPoolWebClientId: process.env.REACT_APP_AWS_CLIENT_ID,

  //     // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
  //     mandatorySignIn: false,

  //     // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
  //     // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
  //     signUpVerificationMethod: 'code', // 'code' | 'link'
  //   },
  //   API: {
  //     endpoints: [
  //       {
  //         name: 'GetBio Api',
  //         endpoint: 'https://t3osyqr1sl.execute-api.us-east-1.amazonaws.com',
  //         custom_header: async () => {
  //           return { Authorization: 'token' };
  //           // Alternatively, with Cognito User Pools use this:
  //           // return { Authorization: `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}` }
  //           // return { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
  //         }
  //       }
  //     ]
  //   },
  // };

  return poolData;
}